import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const ServiceContact = ({ handleWhatsAppClick }) => (
<div className="bg-gradient-to-r from-green-900/40 to-green-950/40 p-10 rounded-2xl border-2 border-green-600/50 text-center my-12">
              <h3 className="text-3xl font-bold text-white mb-4">
                Prêt à Récupérer Votre Ex ?
              </h3>
              <p className="text-gray-300 mb-6 text-lg">
                Consultation gratuite • Résultats garantis • Disponible 7j/7
              </p>
              <Button data-testid="service-contact-whatsapp-button" onClick={handleWhatsAppClick} size="lg" className="max-w-full h-auto whitespace-normal bg-gradient-to-r from-green-500 to-green-600 text-white text-base md:text-xl px-4 md:px-12 py-4 md:py-6">
                <MessageCircle className="w-6 h-6 mr-3 flex-shrink-0" />
                <span>Contacter Maître Diamma WhatsApp</span>
              </Button>
            </div>
);
